import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'
import { installGlobalHandlers, log as devLog } from '@/lib/devLog'

// Registrar handlers globales (window.error / unhandledrejection / console)
// antes de montar la app, así quedan capturados los errores del primer
// render.
installGlobalHandlers()
devLog({
  level: 'info',
  phase: 'log',
  component: 'boot',
  message: `Frontend boot (${import.meta.env.MODE})`,
  detail: {
    userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : undefined,
    href: typeof window !== 'undefined' ? window.location.href : undefined,
  },
})

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
